<!-- @file 地址显示模块 -->
<template>
  <div class="plv-iar-order-address-block" @click="$emit('click')">
    <div v-if="haveAddress" class="plv-iar-oab-info">
      <div class="plv-iar-oab-info__main">{{ dataSource.name }} {{ dataSource.mobile | formatMobileNumber(true) }}</div>
      <div class="plv-iar-oab-info__address">{{ formatedAreaStr }}{{ dataSource.address }}</div>
    </div>
    <span v-else class="plv-iar-oab-placeholder">{{ iarTrans('order.addressPlaceholder') }}</span>
    <div class="plv-iar-oab-right">
      <span v-if="!haveAddress" class="plv-iar-oab-right__text">{{ iarTrans('order.addressRightText') }}</span>
      <i class="plv-iar-oab-right__icon"></i>
    </div>
  </div>
</template>

<script>
import { isEmpty } from 'lodash-es';
import baseMixin from './basicMixin';
import { formatMobileNumber } from '../../assets/utils/utils';

export default {
  mixins: [baseMixin],
  props: {
    dataSource: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    /** 是否有地址 */
    haveAddress() {
      return !isEmpty(this.dataSource);
    },
    /** 格式化地区字符串 */
    formatedAreaStr() {
      if (!this.dataSource) return '';
      return this.dataSource.area?.split('/').join('');
    }
  },
  filters: {
    formatMobileNumber
  }
};
</script>

<style lang="scss">
.plv-iar-order-address-block {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.8);
  border-radius: 8px;
  background: #fff;

  .plv-iar-oab-info__address {
    margin-top: 4px;
    color: rgba(0, 0, 0, 0.4);
  }

  .plv-iar-oab-right {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    color: rgba(0, 0, 0, 0.4);
  }

  .plv-iar-oab-right__icon {
    margin-left: 4px;
    display: block;
    width: 16px;
    height: 16px;
    background: url('./images/right-outlined.svg') no-repeat;
  }
}
</style>
